import { render, staticRenderFns } from "./carMonthStatic.vue?vue&type=template&id=fbfeca4a&"
import script from "./carMonthStatic.vue?vue&type=script&lang=js&"
export * from "./carMonthStatic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports